// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "modules/" + {"3890":"FactCheckHomeAlphaWidget","8015":"FactCheckFcChart","9822":"FactCheckHomeBetaWidget"}[chunkId] + "_module.js?v=" + __webpack_require__.h().slice(0, 8) + "";
};